import React from 'react';
import './Whatsapp.css'
import whatsapp from '../../../Components/Assets/Global/WhatsApp.svg.webp'

const Whatsapp = () => {
    return (
       <>
        <div className='whatapp-section1'>
            <div className='d-flex align-items-center'>
                <h6>Service </h6>
            <a href="https://wa.me/+8801400998844" className="whatsapp-chat" target="_blank"rel="noreferrer"> <img src={whatsapp}
             alt="whatsapp" className='Whatapp-icon'/></a>
            </div>
        </div>
                {/* -----------========---------- */}
        <div className='whatapp-section'>
            <div className='d-flex align-items-center'>
            <h6>Sales</h6>
            <a href="https://wa.me/+8801400992233" className="whatsapp-chat" target="_blank"rel="noreferrer"> <img src={whatsapp}
             alt="whatsapp" className='Whatapp-icon'/></a>
            </div>
        </div>
       </>
    );
};

export default Whatsapp;